import T from 'prop-types'
import Container from 'components/Container'
import Editorial from 'components/Editorial'
import Button from 'components/Button'
import useSession from 'hooks/useSession'
import getGenderText from 'apps/booking/helpers/getGenderText'
import { getJSON } from 'lib/storage'
import Header from 'apps/booking/components/Header'

import { getOptions as getClinicalInformationOptions } from '../wizard/steps/ClinicalInformation'
import { getOptions as getWomanOptions } from '../wizard/steps/WomanQuestions'

const ERROR_MESSAGES = {
  HAS_SYMPTOMS:
    'Du kan ikke ta vaksinen så lenge du har forkjølelsessymptomer eller feber over 38 °C.',
  IN_QUARANTINE:
    'Du kan ikke ta vaksinen så lenge du er i karantene eller isolasjon grunnet koronasykdom.',
  RECENTLY_HAD_COVID:
    'Du kan ikke ta vaksinen siden du har gjennomgått koronasykdom for mindre enn 3 uker siden.',
  RECENT_FLU_VACCINE:
    'Du må vente minst 7 dager etter å blitt vaksinert med en annen vaksine før du kan ta koronavaksinen.',
}

export default function ClinicalRejectionPage({
  match: {
    params: { orgUnit },
  },
}) {
  const { clearSession, session } = useSession()
  const { user_id } = session || {}

  const values = getJSON('bookingState')
  const mvpVaccinationValidator = [
    ...getWomanOptions(values, user_id),
    ...getClinicalInformationOptions(values, user_id),
  ]

  const declarations = values?.vaccination.self_declaration || []
  const hasCurrentVaccination = !!values?.vaccinationId

  // Validate
  const errors = mvpVaccinationValidator
    .filter(({ name, requiredValue }) => {
      // User submitted answer
      const current = declarations.find(({ question }) => question === name)?.answer
      // Check against expected value (if not undefined)
      const match = requiredValue !== undefined && requiredValue !== current
      return match
    })
    .map(({ name }) => name)

  const moreThanOneError = errors.length > 1

  return (
    <>
      <Header seoTitle={getGenderText('%S kan desverre ikke ta vaksinen nå', values)} />

      <Container size="wizard" style={{ paddingBottom: '3rem' }}>
        <h1>{getGenderText('%S kan desverre ikke ta vaksinen nå', values)}</h1>

        <Editorial>
          {moreThanOneError ? (
            <ul>
              {errors.map((question) => (
                <li key={question}>{ERROR_MESSAGES[question]}</li>
              ))}
            </ul>
          ) : (
            <p>{ERROR_MESSAGES[errors[0]]}</p>
          )}

          {hasCurrentVaccination && (
            <p>
              Vennligst ta kontakt med din kommune for å flytte timen. Dette er viktig, da timen din
              ikke automatisk blir avbestilt.
            </p>
          )}

          {!hasCurrentVaccination && (
            <>
              <h2>Du kan prøve igjen senere!</h2>
              <p>
                Du kan komme tilbake og logge inn så snart situasjonen har endret seg.
                <br />
                <br />
                Eksempelvis:
                <br />
                Hvis du er i karantene kan du prøve igjen så snart karantenetiden er ferdig.
              </p>
            </>
          )}
        </Editorial>

        <Button onClick={() => clearSession(`/${orgUnit}`)} primary>
          Avslutt og logg ut
        </Button>
      </Container>
    </>
  )
}

ClinicalRejectionPage.propTypes = {
  match: T.shape({
    params: T.shape({
      orgUnit: T.string.isRequired,
    }).isRequired,
  }).isRequired,
}
